const TOPICS = [
  { label: '热血少年', hot: true, count: '2.3w' },
  { label: '恋爱甜宠', hot: true, count: '1.8w' },
  { label: '悬疑推理', hot: true, count: '1.5w' },
  { label: '奇幻冒险', hot: false, count: '1.2w' },
  { label: '搞笑日常', hot: false, count: '9.8k' },
  { label: '治愈温情', hot: true, count: '8.6k' },
  { label: '古风仙侠', hot: false, count: '7.2k' },
  { label: '都市职场', hot: false, count: '6.5k' },
  { label: '科幻末世', hot: false, count: '5.1k' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading">
            热门话题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            探索当下最受漫画迷关注的话题标签
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((topic, idx) => (
            <div
              key={idx}
              className={`group relative inline-flex items-center gap-2 px-4 py-2 rounded-full cursor-pointer transition-all duration-300 ${
                topic.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200'
                  : 'bg-background-100 text-foreground-600 hover:bg-background-200 border border-background-200/70'
              }`}
            >
              {topic.hot && (
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
              )}
              <span className="text-sm font-medium whitespace-nowrap">{topic.label}</span>
              <span className="text-xs opacity-70">{topic.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}